import { jwtDecode } from "jwt-decode";
import { BitacoraService } from "../services/apiService";
import dayjs from "dayjs";

export const AccionBitacora = {
    IniciarSesion: 0,
    EntrarReporte: 1,
    Generar: 2,
    Exportar: 3,
    Imprimir: 4,
};

export const generarObservacion = (titulo, filtros) => {
    let tiempoStr = filtros.consumos ? `, el mes ${filtros.mes}` : `, desde ${filtros.fecha_inicio} a las ${filtros.hora_inicio} hasta ${filtros.fecha_fin}`;
    let gruposStr = `${filtros.grupos ? `, con los grupos ${filtros.grupos}` : ''}`;
    let vehiculosStr = `${filtros.vehiculos ? `, los vehículos: ${filtros.vehiculos}` : ''}`;
    let tipoAlertaStr = `${filtros.tipoAlertas ? `, las alertas: ${filtros.tipoAlertas}` : ''}`;
    let consumos = `${filtros.consumos ? `, los consumos de tipo: ${filtros.consumos}` : ''}`;
    let usuarios = `${filtros.usuarios ? `, los usuarios: ${filtros.usuarios}` : ''}`;
    return `${titulo}${tiempoStr}${gruposStr}${vehiculosStr}${tipoAlertaStr}${consumos}${usuarios}`;
};

export const guardarBitacora = (observaciones) => {
    const token = localStorage.getItem('token');
    if (token) {
        try {
            let tipoAccionStr = ['inicio sesión', 'ingreso al reporte:', 'género un reporte', 'exporto un reporte', 'imprimió un reporte'];
            let tipoAccion = ['Login', 'Entro', 'Generar', 'Exportar', 'Imprimir'];
            const decoded = jwtDecode(token);
            let accionStr = `${observaciones.tipoAccion === AccionBitacora.IniciarSesion ? 'en Reportería GPS' : `${observaciones.observacion}`}`;
            let observacionStr = observaciones ?
                `El usuario ${decoded.usuario} ${tipoAccionStr[observaciones.tipoAccion]} ${accionStr}.`
                : '';
            let bitacora = {
                'Observaciones': observacionStr,
                'Accion': tipoAccion[observaciones.tipoAccion],
                'Categoria': observaciones.categoria,
                'UserHost': window.location.hostname,
            };
            BitacoraService.addBitacora(bitacora);
        } catch (error) {

        }
    };
}    